module.exports = __webpack_public_path__ + "img/dimi.609e5323.svg";